import React, { useState } from "react";
import { CheckboxList, Item } from "../../../common/formFields/CheckboxList";
import { Row, Col } from "react-bootstrap";
import '../../../common/formFields/FormField.scss';
import DateField from '../../../common/formFields/DateField';
import Checkbox from '@material-ui/core/Checkbox';
import { _ } from "../../../common/utils/appUtils";
import { Release, SensitiveInfoRelease } from "../../../models/transaction";

interface InfoToReleaseProps {
    data: readonly Release[],
    onChangeItem?: (itemId: number, checked: boolean, from: Date | undefined, to: Date | undefined, all: boolean) => void,
    onChangeDates?: (from: Date | undefined, to: Date | undefined, all: boolean) => void,
    freeText?: string,
    onChangeFreeText?: (freeText: string) => void,
    fromErrorMsg: string,
    toErrorMsg: string,
    errorMsg: string,
    minDate?: Date,
    maxDate?: Date,
    initialLoad: boolean
}

export default function InfoToRelease(props: InfoToReleaseProps) {
    const { data } = props;

    const [items, setItems] = useState<readonly Item[]>(data.map(item => ({
        id: item.id,
        state: item.checked ? SensitiveInfoRelease.Authorized : SensitiveInfoRelease.NotMentioned,
        label: item.name,
    })));

    const checkedItem = data.find(item => item.checked);
    const [fromDate, setFromDate] = useState<Date | undefined>(checkedItem?.dateOfService?.from);
    const [toDate, setToDate] = useState<Date | undefined>(checkedItem?.dateOfService?.to);
    const [allDates, setAllDates] = useState(checkedItem?.allDates ?? false);

    const fromMinDate = props.minDate;
    const fromMaxDate = toDate ?? props.maxDate;
    const toMinDate = fromDate ?? props.minDate;
    const toMaxDate = props.maxDate;
    const anyError = props.fromErrorMsg || props.toErrorMsg || props.errorMsg;

    const allFieldsEmpty: boolean = (fromDate === undefined) && (toDate === undefined) && (allDates === false) && (checkedItem === undefined);


    function onChangeItem(itemId: number, checked: boolean) {
        setItems(items.map(item => item.id == itemId ? {
            ...item,
            state: checked ? SensitiveInfoRelease.Authorized : SensitiveInfoRelease.NotMentioned
        } : item));

        if (allDates) { props.onChangeItem?.(itemId, checked, undefined, undefined, true); }
        else { props.onChangeItem?.(itemId, checked, fromDate, toDate, false); }

    }

    const changeFromDate = (date?: Date | string) => {
        date = typeof (date) == "string" ? new Date(date) : date;
        if (isNaN(date?.getTime() ?? 0)) {
            date = undefined;
        }
        setFromDate(date);
        setAllDates(date == undefined && allDates);
        props.onChangeDates?.(date, toDate, date == undefined && allDates);
    }

    const changeToDate = (date?: Date | string) => {
        date = typeof (date) == "string" ? new Date(date) : date;
        if (isNaN(date?.getTime() ?? 0)) {
            date = undefined;
        }
        setToDate(date);
        setAllDates(date == undefined && allDates);
        props.onChangeDates?.(fromDate, date, date == undefined && allDates);
    }

    const changeAllDates = (state: boolean) => {
        setAllDates(state);
        if (state) {
            setFromDate(undefined);
            setToDate(undefined);
            props.onChangeDates?.(undefined, undefined, state);
        } else {
            props.onChangeDates?.(fromDate, toDate, state);
        }
    }


    return <div id="infotorelease" style={{ marginBottom: "30px" }}>
        <div className="new-panel-header section-headers">
            Information to Release
        </div>
        <div className="new-panel-body panel-body sensitive-information-accordion">
            <div className="sensitive-info-header">
                <div className="sensitive-info-question">
                    Select records and the date range that have been requested
                </div>
            </div>
            {props.errorMsg && !(props.initialLoad && allFieldsEmpty) && <div className="error-message Phi-text rtr-alert-icon-after">
                {props.errorMsg}
            </div>}
            <div className={"sensitive-Info-inner" + (!(props.initialLoad && allFieldsEmpty) && anyError ? " inputError" : "")}>

                <Row>
                    <Col>
                        <DateField
                            label="From"
                            value={fromDate}
                            placeholder="mm/dd/yyyy"
                            errMsg={props.fromErrorMsg || ""}
                            onChange={changeFromDate}
                            minDate={fromMinDate}
                            maxDate={fromMaxDate}
                        />
                    </Col>
                    <Col>
                        <DateField
                            label="To"
                            value={toDate}
                            placeholder="mm/dd/yyyy"
                            errMsg={props.toErrorMsg || ""}
                            onChange={changeToDate}
                            minDate={toMinDate}
                            maxDate={toMaxDate}
                        />
                    </Col>
                    <Col>
                        <Checkbox
                            checked={allDates}
                            onChange={e => changeAllDates(e.currentTarget.checked)}
                        />
                        All Dates
                    </Col>
                </Row>
                <CheckboxList
                    items={items}
                    checkboxHeader="RETRIEVE"
                    labelHeaders={["RECORD TYPE"]}
                    onChange={onChangeItem}
                    className="checkboxSection"
                    freeText={props.freeText}
                    hasFreeText={(item) => item && item.id === 31}
                    onChangeFreeText={props.onChangeFreeText}
                    freeTextMaxLen={2000}
                    allowUncheck
                />
            </div>
        </div>
    </div>
}
